import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../maintenance/Maintenance.css";
import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Outstation_Rides = () => {
  return (
    <section className="Outstation_Rides service">
      <Container>
        <h4 className="service_title">Outstation Rides</h4>


        <Component1
          title1="Safe & Reliable Long-Distance"
          title2="Travel"
          title3="Traveling long distances has never been easier and more comfortable with our Outstation Ride services. Whether it’s a business trip, a family vacation, or a weekend getaway, we provide safe, reliable, and convenient transportation tailored to your needs. Our fleet of well-maintained vehicles ensures a smooth and comfortable journey, while our professional drivers prioritize punctuality, safety, and excellent service at every mile.With flexible scheduling and transparent pricing, you can plan your trips without any hassle. We offer door-to-door service, route customization, and support throughout your journey, so you can relax and enjoy the ride while we handle all the logistics. From city-to-city travel to inter-state trips, our Outstation Rides are designed to make long-distance travel stress-free, convenient, and enjoyable."
          imgSrc="/assets/images/services/outstation.png"
        />


        <Component2
          title="Pre-Trip & On-Road Process"
          tips={[
            "Our Outstation ride process begins well before you step into the vehicle. Each trip is carefully planned, starting with route assessment, vehicle readiness checks, and scheduling to ensure punctuality and efficiency. Our vehicles undergo thorough inspections, including engine performance, tire condition, fuel levels, and safety systems, so that you can travel with confidence.",
            "Once on the road, our professional drivers maintain constant vigilance, following best driving practices, traffic regulations, and safety protocols to ensure a smooth and secure journey. We monitor the progress of your trip, provide timely updates, and remain available for any assistance you may need along the way. From pre-trip preparation to arrival at your destination, every step is designed to offer a comfortable, reliable, and stress-free travel experience.",

          ]}
          list={true}
        />


        <Component2
          title="Benefits of Outstation Services"
          tips={[
            "Your vehicle is monitored throughout the process, reducing the stress of managing outstation servicing.",
            "Schedule services at a time that suits you, even for long-distance or remote locations.",
            "Trained staff ensures your vehicle is transported safely and serviced efficiently.",
            "Your vehicle is collected, serviced, and returned, letting you focus on your work or personal commitments.",
            "Pick-up and drop-off services save you the hassle of traveling to service centers."
          ]}
          list={true}
        />


        <Component3
          title="Travel Tips"
          tips={[
            "Ensure your vehicle is well-maintained, with tires, brakes, lights, and fluids in good condition.",
            "Carry water, snacks, first-aid kit, spare tire, and basic tools for emergencies.",
            "Follow traffic rules, maintain a safe distance, and avoid distractions while driving.",
            "Take breaks during long drives to stay alert and prevent fatigue.",
            "Carry your driver’s license, registration, insurance, and other necessary documents."
          ]}
          list={true}
        />
      </Container>
    </section>
  );
};

export default Outstation_Rides;
